import BannerPlaybook from './bannerPlaybook.view';

export default BannerPlaybook;
